import { render, staticRenderFns } from "./LayerCompare.vue?vue&type=template&id=bf2935be&scoped=true&"
import script from "./LayerCompare.vue?vue&type=script&lang=js&"
export * from "./LayerCompare.vue?vue&type=script&lang=js&"
import style0 from "./LayerCompare.vue?vue&type=style&index=0&id=bf2935be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2935be",
  null
  
)

export default component.exports